import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { log } from 'console';
import {
  APIService,
  ModelBulkCodebookImportInput,
  ModelCreatePresignedURLInput,
} from 'src/app/API.service';

@Component({
  selector: 'app-sifrarnik-bulk-import',
  templateUrl: './sifrarnik-bulk-import.component.html',
  styleUrls: ['./sifrarnik-bulk-import.component.css'],
})
export class SifrarnikBulkImportComponent implements OnInit {
  files: string[] = [];
  fileUrl: string = '';
  hasError: boolean = false;
  loading: boolean = false;
  userID: string = '';
  csvTemplateUrl: string = `https://cf-invoices-storage74835-dev.s3.eu-central-1.amazonaws.com/csv/codebook-bulk-import-template-v1.csv`;
  constructor(
    private snackBar: MatSnackBar,
    private apiService: APIService,
    private http: HttpClient,
    private dialogRef: MatDialogRef<SifrarnikBulkImportComponent>
  ) {}

  ngOnInit(): void {
  }

  async getPresignedUrl(file: any) {
    this.hasError = false;
    let name = file.name;
    let data: ModelCreatePresignedURLInput = {
      originalFileName: name,
      profile: 'bulkUpload',
      action: 'upload',
    };
    this.apiService
      .CreatePresignedURL(data)
      .then((response: any) => {
        this.uploadFile(response.url, file);
        this.fileUrl = response.url.split('?')[0];
      })
      .catch((err) => console.log(err));
  }

  uploadFile(url: string, file: any) {
    const formData = new FormData();
    formData.append('file', file);

    const headers = new HttpHeaders();
    headers.set('Content-Type', 'multipart/form-data');

    this.http.put(url, file.rawFile, { headers: headers }).subscribe(
      (response) => {
        console.log('File upload successful!', response);
      },
      (error) => {
        console.error('File upload error:', error);
      }
    );
  }

  addCsv() {
    this.loading = true;
    let data: ModelBulkCodebookImportInput = {
      csvUrl: this.fileUrl,
    };
    this.apiService
      .BulkCodebookImport(data)
      .then((response: any) => {
        this.userID = localStorage.getItem('userID') || '';

        if (response.result.toLowerCase() == 'failed') {
          this.hasError = true;
        } else {
          setTimeout(() => {
            this.dialogRef.close(true);

            setTimeout(() => {
              this.snackBar.open('Bulk file successfully added', '', {
                duration: 5000,
                panelClass: ['white-snackbar'],
              });
            }, 3000);
            this.loading = false;
          }, 4000);
        }
      })
      .catch((err) => {
        this.snackBar.open('Error', '', {
          duration: 5000,
          panelClass: ['white-snackbar'],
        });
        console.log(err);
        this.loading = false;
      });
  }
}
